import * as Yup from 'yup';
import { testPhoneNumbervalue } from '../global/helper';
import { getEmailSchema } from '../../types/global';

export interface CreateCustomerValues {
  firstName: string;
  phoneNumber: string;
  lastName?: string;
  email?: string;
  dob?: string;
  internalNotes?: string;
  // address
  streetAddress?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  zip?: string;
  // emergency contact
  ecFirstName?: string;
  ecLastName?: string;
  ecPhoneNumber?: string;
  ecEmail?: string;
}

export const initFormValues: CreateCustomerValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  dob: '',
  internalNotes: '',
  streetAddress: '',
  streetAddress2: '',
  city: '',
  state: '',
  zip: '',
  ecFirstName: '',
  ecLastName: '',
  ecPhoneNumber: '',
  ecEmail: '',
};

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  phoneNumber: Yup.string()
    .test({
      test: testPhoneNumbervalue,
      message: 'Invalid phone number',
    })
    .required('Phone number is required'),
  lastName: Yup.string(),
  email: getEmailSchema('Invalid email', false),
  dob: Yup.date(),
  internalNotes: Yup.string(),
  streetAddress: Yup.string(),
  streetAddress2: Yup.string(),
  city: Yup.string(),
  state: Yup.string(),
  zip: Yup.string(),
  ecFirstName: Yup.string(),
  ecLastName: Yup.string(),
  ecPhoneNumber: Yup.string()
    .test({
      test: val => !val || testPhoneNumbervalue(val),
      message: 'Invalid phone number',
    })
    .nullable()
    .optional(),
  ecEmail: getEmailSchema('Invalid emergency contact email', false),
});
